import { Actions } from '../../interfaces'
import { VehicleGama } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { VehicleGama },
  actions: { [VehicleGama.name]: actions },
}
